<template>
  <div class="managingPeople hp100 bbox" v-loading="loading">
    <!-- 卡片视图 -->
    <el-card>
      <!-- 搜索-->
      <el-row :gutter="20" type="flex" justify="space-between">
        <el-col>
          <el-button
            plain
            class="add-column-btn bbox"
            @click="gotoDetail('')"
            type="primary"
          >
            <i class="el-icon-plus fw900 f16"></i> 新增</el-button
          >
          <el-button
            plain
            class="add-column-btn bbox"
            type="warning"
            @click="chooseDelete"
          >
            <i class="el-icon-delete fw900 f16"></i> 删除</el-button
          >
        </el-col>
        <el-col>
          <div class="flex align-center justify-end header-search-box">
            <el-input
              placeholder="查询条件"
              clearable
              v-model="searchInput"
              class="header-search-input ml10"
              @change="search"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                class="textblue searchBtn"
                @click="search()"
              ></el-button>
            </el-input>
          </div>
        </el-col>
      </el-row>
      <!-- 用户列表区域 -->
      <div :style="{ height: height + 'px' }" style="margin-top: 20px">
        <el-scrollbar style="height: 100%; width: 100%">
          <el-row style="width: 100%">
            <el-table
              :data="tableData"
              border
              fit
              highlight-current-row
              style="width: 100%"
              @sort-change="sortChange"
              @selection-change="handleSelectionChange"
            >
              <el-table-column type="selection" width="55" align="center">
              </el-table-column>
              <el-table-column label="组织编码" align="center" prop="组织编码">
                <template slot-scope="scope">
                  <span>{{ scope.row.groupCode }}</span>
                </template>
              </el-table-column>
              <el-table-column label="组织名称" align="center" prop="组织名称">
                <template slot-scope="scope">
                  <span>{{ scope.row.groupName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="排序" align="center" prop="排序">
                <template slot-scope="scope">
                  <span>{{ scope.row.seq }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="操作"
                align="center"
                class-name="small-padding fixed-width"
              >
                <template slot-scope="scope">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="编辑"
                    placement="bottom"
                  >
                    <i
                      class="el-icon-edit textblue f16"
                      @click="gotoDetail(scope.row.id, scope.row.userCode)"
                    ></i>
                  </el-tooltip>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="删除"
                    placement="bottom"
                  >
                    <i
                      class="el-icon-delete textblue f16 ml20"
                      @click="del(scope.row.id)"
                    ></i>
                  </el-tooltip>
                </template>
              </el-table-column>
            </el-table> </el-row
        ></el-scrollbar>
      </div>
      <div class="footerBox">
        <!-- 分页区域 -->
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="queryInfo.currPage"
          :page-sizes="[100, 10, 20, 30, 50]"
          :page-size="queryInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      height: window.innerHeight - 256, //表格高度
      value: "",
      searchInput: "",
      tableData: [],
      loading: true,
      // 获取用户列表查询参数对象
      queryInfo: {
        // 当前页数
        currPage: 1,
        // 每页显示多少数据
        pageSize: 100,
        //查询条件
        condition: {
          id: "",
        },
      },
      userlist: [],
      total: 0,
      // 添加用户对话框
      addDialogVisible: false,
      // 用户添加
      addUserForm: {
        username: "",
        password: "",
        email: "",
        mobile: "",
      },
      // 修改用户
      editDialogVisible: false,
      editUserForm: {},
      // 分配角色对话框
      setRoleDialogVisible: false,
      checkList: [],
    };
  },
  created() {
    this.queryInfo.currPage = Number(this.$route.query.currPage);
    this.queryInfo.pageSize = Number(this.$route.query.pageSize);
    this.getListData();
    window.addEventListener("resize", this.getHeight);
  },
  mounted() {
    this.loading = false;
  },
  destroyed() {
    window.removeEventListener("resize", this.getHeight);
  },
  methods: {
    //条件查询
    search() {
      this.queryInfo.condition.searchField = this.searchInput;
      this.getListData();
    },
    // 监听 pagesize改变的事件
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize;
      this.getListData();
    },
    // 监听 页码值 改变事件
    handleCurrentChange(newSize) {
      this.queryInfo.currPage = newSize;
      this.getListData();
    },

    // 监听排序
    sortChange() {},
    //跳转到详情
    gotoDetail(id) {
      var that = this;
      this.$router.push({
        path: "/group/details",
        query: {
          id: id,
          currPage: that.queryInfo.currPage,
          pageSize: that.queryInfo.pageSize,
        },
      });
    },

    // 删除用户
    async del(id) {
      const confirmResult = await this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).catch((err) => err);
      if (confirmResult === "confirm") {
        var that = this;
        that.$http.post("/group/delete", { id: id }).then(function (response) {
          if (response.data.code == 200) {
            that.$notify.success({
              title: "提示",
              message: "删除成功",
              showClose: true,
            });
            that.getListData();
          }
        });
      }
    },
    getListData() {
      // 获取列表
      var that = this;
      that.$http.post("/group/list", that.queryInfo).then(function (response) {
        console.log(response.data.data);
        if (response.data.code == 200) {
          that.total = response.data.data.count;
          that.queryInfo.currPage = response.data.data.currPage;
          that.tableData = response.data.data.data;
        }
      });
    },
    // 监听表格高度
    getHeight() {
      this.height = window.innerHeight - 256;
    },
    // 选择列
    handleSelectionChange(val) {
      console.log("批量删除", val);
      this.checkList = val;
    },
    // 选择删除
    chooseDelete() {
      if (this.checkList.length == 0) {
        this.$message("请选中一条记录！");
        return;
      }
      console.log("12cheeckList", this.checkList);
      let checkArr = [];
      this.checkList.forEach((item) => {
        checkArr.push(item.id);
      });
      console.log("chjeckArr", checkArr);
      this.$http.post("/group/delBatch", checkArr).then((res) => {
        console.log(res.data.data);
        if (res.data.code == 200) {
          this.$notify.success({
            title: "提示",
            message: "删除成功",
            showClose: true,
          });
          this.getListData();
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.textblue {
  color: #008eff;
}
.managingPeople {
  .el-card {
    height: calc(100vh - 114px);
    position: relative;
    .el-select > .el-input {
      width: 200px;
    }
    .header-search-box .header-search-input {
      width: 325px;
    }
    input::placeholder {
      font-size: 12px;
    }
    .handle-btn .el-button.add-column-btn {
      width: 100%;
      font-size: 13px;
      background-color: transparent;
      color: #008eff;
      z-index: 102;
    }
    .footerBox {
      position: absolute;
      width: 100%;
      height: 78px;
      left: 20px;
      right: 20px;
      bottom: 0;
    }
  }
}
/deep/.el-scrollbar__view {
  min-width: 100%;
}
/deep/.el-scrollbar__wrap {
  overflow-x: auto;
  height: calc(100%); //多出来的20px是横向滚动条默认的样式
  width: 100%;
}
/deep/.el-scrollbar .el-scrollbar__wrap .el-scrollbar__view {
  white-space: nowrap;
  display: inline-block;
}
</style>

